// extracted by mini-css-extract-plugin
export default {"image":"pZ-z","loaded":"qZ-z"};